// Arquivo: admin-panel/src/utils/api.js

import axios from "axios";

// 1. Cria uma instância do Axios com a URL base
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // baseURL para a sua API em Node.js
  timeout: 10000,
});

// 2. Interceptador de Requisições: ADICIONA O TOKEN
// Esta função roda antes de CADA requisição (GET, POST, PUT, DELETE)
api.interceptors.request.use(
  (config) => {
    // Pega o token do armazenamento local (definido no LoginAdmin.js)
    const token = localStorage.getItem("adminToken");

    // Se o token existir, anexa-o ao cabeçalho "Authorization" (padrão Bearer)
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 3. Interceptador de Respostas: Tratar 401 (Não Autorizado)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Se a API retornar 401, significa que o token expirou ou é inválido
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("adminToken"); // Remove o token inválido
      window.location.href = "/login"; // Força o redirecionamento para o login
    }
    return Promise.reject(error);
  }
);

export default api;
